import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type { TypePutSalesChannelParams, TypePutSalesChannelResponse } from '~/types/product.types';

const ENDPOINT = '/api-lip/v1/third-parties/sales-channel';

/**
 * [상품관리][상품 판매처 매핑] 상품 판매처 수정 API
 */
export const fetchPutSalesChannel = async (params: TypePutSalesChannelParams) => {
  const { data } = await axiosInstance.put<TypePutSalesChannelResponse>(ENDPOINT, { ...params });
  return data.data;
};

/**
 * [상품관리][상품 판매처 매핑] 상품 판매처 수정 Mutation Hook
 */
export const usePutSalesChannelMutation = () => {
  return useMutation({
    mutationFn: fetchPutSalesChannel,
  });
};
